import React, { useState } from 'react';
import { Box, Button, Container, Stack } from '@mui/material';
import { useUser } from '../../userContext';
import { toast } from 'react-toastify';
import CancelIcon from '@mui/icons-material/Cancel';

export default function NotificationBar() {  
  const { authenticated, userId } = useUser();
  const [ userNotifications, setUserNotifications] = useState([]);
  const [ initialLoad, setInitialLoad ] = useState(true);
  
  const getDate = () => {
      const now = new Date();
      const formatted = now.toLocaleString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      });

      return formatted;
  }

  const closeNotification = async (notification) => {
    if (notification) {
        setUserNotifications(userNotifications.filter(userNotification => userNotification.id !== notification.id));
        const formData = { user_id: userId, notification_id: notification.id, notification_date: getDate() }
        try {
            const response = await fetch(`${process.env.REACT_APP_API}/userNotifications/create`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(formData),
            });
            if (!response.ok) {
                toast.error(`HTTP error! status: ${response.status}`);
            }
        } catch (error) {
            toast.error(error);
        } 
    }
  }

  const fetchUserNotifications = async () => {
      try {              
          const response = await fetch(`${process.env.REACT_APP_API}/notifications/active`);
          if (!response.ok) {
              toast.error(`HTTP error! status: ${response.status}`);
          } else {
              const json = await response.json();
              if ( json.message !== 'No Records To Display' ) {
                const allNotifications = json.data;

                allNotifications.forEach( async (incNotification) => {
                    const userNotificationData = { 
                        user_id: userId,
                        notification_id: incNotification.id
                    }

                    const userNotificationResponse =  await fetch(`${process.env.REACT_APP_API}/userNotifications/getById`, {
                        method: 'PUT',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(userNotificationData),
                    });

                    if (!userNotificationResponse.ok) {
                        toast.error(`HTTP error! status: ${userNotificationResponse.status}`);
                    } else {
                        const json = await userNotificationResponse.json();
                        if (json.message === 'No Records To Display') {
                            setUserNotifications(prev => [...prev, incNotification]);
                        }
                    }
                });
              }
          }
      } catch (error) {
          toast.error(error);
      } 
  }

  if (initialLoad) {
    fetchUserNotifications();    
    setInitialLoad(false);
  }

  return (
    <>
      { authenticated &&              
          <Container align="center" maxWidth={true} sx={{ maxHeight:'50px', width: '100%', maxWidth: 'none', bgcolor: '#FF0000' }}>
              {userNotifications.map((notification, index) => ( 
                      <Stack direction="row" sx={{ width: '100%' }}>
                          <Box sx={{ flexGrow: 1, p: 1 }}>
                            <p key={index}>
                                {notification.description}
                            </p> 
                          </Box>
                          <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginRight: '150px' }}>                          
                            <Button onClick={() => closeNotification(notification)} size="small" style={{ color: 'white' }} >
                                <CancelIcon />
                            </Button>
                          </Box>
                      </Stack>
                ))
              }

          </Container>    
      }
    </>
  );
}
